import { EraQL } from '@cotera/era';
import { SYSTEM_TABLES } from '../../runtime/system-tables';

const EVENTS_TABLE: EraQL.Item = {
  t: 'rel',
  rel: SYSTEM_TABLES.entity_events,
};

const STABLE_IDS: EraQL.Item = {
  t: 'rel',
  rel: SYSTEM_TABLES.stable_ids,
};

const USER_DEFINED_DIMENSIONS: EraQL.Item = {
  t: 'rel',
  rel: SYSTEM_TABLES.user_defined_dimensions,
};

export const GRAPH_CONSTANTS: EraQL.Bindings = {
  EVENTS_TABLE,
  STABLE_IDS,
  USER_DEFINED_DIMENSIONS,
};
